import {DependencyList, EffectCallback, useEffect} from 'react'

export const usePageChange = (callback: EffectCallback, dependencies: DependencyList = []) => {
	useEffect(() => {
		const abortController = new AbortController()

		window.addEventListener('page-change', callback, {signal: abortController.signal})

		return () => abortController.abort()
	}, dependencies)
}
